export default window._cmsContent['solar/home-v2']